import { apiClient } from './client'

export type DueCardType = 'due_date' | 'video_request' | 'done' | 'editing'

export interface DueCardRow {
  card_id?: number
  card_title: string
  card_status: string
  date_field: string
  firstname: string | null
  lastname: string | null
  qa_firstname: string | null
  qa_lastname: string | null
  client_id: number
}

export const dueCardsApi = {
  byDate: (params: { dueDate: string; viewAsCardType: DueCardType; viewAsCustomer?: string | number; viewAsQA?: string | number }) =>
    apiClient
      .get<DueCardRow[]>('/api/get-cards-by-due-date', {
        params: {
          viewAsCustomer: params.viewAsCustomer ?? '',
          viewAsQA: params.viewAsQA ?? '',
          dueDate: params.dueDate,
          viewAsCardType: params.viewAsCardType,
        },
      })
      .then((r) => (Array.isArray(r.data) ? r.data : [])),
}
